import {z as r} from 'zod';

import {BulkUpdateCompaniesFilterType} from '../company/company-type';

export const phoneCommentVisibilitySchema = r.object({
    isVisible: r.boolean(),
});

export type PhoneCommentVisibilityType = r.infer<typeof phoneCommentVisibilitySchema>;

// The backend takes exactly one of these. `filter` carries the same shape the bulk update applies
// on save, so "select all minus excluded" — which has no explicit id list — stays in sync with it.
export type PhoneCommentVisibilityPayloadType =
    | {companyIds: Array<number>}
    | {companiesSelectorUid: string}
    | {filter: BulkUpdateCompaniesFilterType};
